import { Carousel } from "antd";

const photos = [
  'l-r-logo.png',
  './IMG_2142.JPG',
  './IMG_2144.JPG',
  './IMG_8183.png',
  './IMG_2109.JPG',
  './IMG_7251.png',
  './IMG_7388.png',
  './IMG_1147.JPG',
];

const PhotoCarousel = () => {
    return (
      <div style={{ width: '100%', maxWidth: 600 }}>
        <Carousel autoplay arrows>
          {photos.map((photo, index) => (
            <div key={index}>
              <img 
                src={photo} 
                alt={`Wedding ${index + 1}`}
                style={{ 
                  width: '100%', 
                  height: 400,
                  objectFit: 'cover',
                  borderRadius: 24
                }} 
              />
            </div>
          ))}
        </Carousel>
      </div>
    )
}

export default PhotoCarousel;